import { Theme } from '@busybusy/webapp-react-ui';
import { CertificationOptions } from '__generated__/graphql';
import classNames from 'classnames';
import DashboardContentRibbon from 'components/foundation/dashboard/DashboardContentRibbon/DashboardContentRibbon';
import DashboardRibbonGroup from 'components/foundation/dashboard/DashboardRibbonGroup/DashboardRibbonGroup';
import { CertificationsExpirationOptions } from 'containers/certification-status-report/CertificationStatusReportFilter/CertificationStatusReportFilter';
import { CertificationStatusReportTabType } from 'containers/certification-status-report/CertificationStatusReportTabHeader/CertificationStatusReportTabHeader';
import { useActiveMember } from 'hooks';
import useCertificationsReportNavigation from 'hooks/navigation/useCertificationsReportNavigation';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';
import { useFeatureFlags } from 'utils/features';
import useCertificationCounts from './hooks/useCertificationCounts';

export interface ICertificationsDashboardCardProps {
  theme: Theme.DARK | Theme.LIGHT;
  className?: ClassName;
}

const CertificationsDashboardCard = (props: ICertificationsDashboardCardProps) => {
  const { className, theme } = props;

  const member = useActiveMember();
  const isCertificationsEnabled =
    (useFeatureFlags('CERTIFICATIONS') ?? false) && member.position?.certifications === CertificationOptions.ManageAll;
  const navigationToReport = useCertificationsReportNavigation();
  const { expired, expiring, loading } = useCertificationCounts(isCertificationsEnabled);
  const expiredCount = expired.toString();
  const aboutToExpireCount = expiring.toString();

  function handleNavigation(
    reportType: CertificationStatusReportTabType,
    expirationDate?: CertificationsExpirationOptions
  ) {
    navigationToReport({
      certification_expiration_date: expirationDate,
      certification_report_type: reportType,
    });
  }

  const classes = classNames('certifications-dashboard-card', className);

  return (
    <>
      {isCertificationsEnabled && (
        <DashboardRibbonGroup className={classes}>
          <DashboardContentRibbon
            theme={theme}
            onClick={() => handleNavigation(CertificationStatusReportTabType.EXPIRED)}
            title={t('Expired Certifications')}
            subtitle={t('All')}
            value={expiredCount}
            isLoading={loading}
          />
          <DashboardContentRibbon
            theme={theme}
            onClick={() =>
              handleNavigation(CertificationStatusReportTabType.ACTIVE, CertificationsExpirationOptions.THIRTY_DAYS)
            }
            title={t('Expiring Certifications')}
            subtitle={t('Within 30 Days')}
            value={aboutToExpireCount}
            isLoading={loading}
          />
        </DashboardRibbonGroup>
      )}
    </>
  );
};

export default CertificationsDashboardCard;
